// Author : Vishnu
//Version :0.0.1
// MODIFIED DATE: 04/8/2025
import groupActionTypes from './group.types';

/** ***************** ADD GROUP DETAILS START *********************** */
export const addGroupDetailsStart = (addData: any) => ({
	type: groupActionTypes.ADD_GROUP_DETAILS_START,
	payload: addData,
});

export const addGroupDetailsSuccess = (successData: any) => ({
	type: groupActionTypes.ADD_GROUP_DETAILS_SUCCESS,
	payload: successData,
});

export const addGroupDetailsFailure = (failureData: any) => ({
	type: groupActionTypes.ADD_GROUP_DETAILS_FAILURE,
	payload: failureData,
});

export const addGroupDetailsResponseResetStart = () => ({
	type: groupActionTypes.ADD_GROUP_DETAILS_RESPONSE_RESET,
});

export const addGroupDetailsResponseChanged = () => ({
	type: groupActionTypes.ADD_GROUP_DETAILS_RESPONSE_CHANGED,
});

/** ***************** ADD GROUP DETAILS END *********************** */

/** ***************** GET GROUP LIST START *********************** */
export const getGroupListStart = (getData: any) => ({
	type: groupActionTypes.GET_GROUP_LIST_START,
	payload: getData,
});

export const getGroupListSuccess = (successData: any) => ({
	type: groupActionTypes.GET_GROUP_LIST_SUCCESS,
	payload: successData,
});

export const getGroupListFailure = (failureData: any) => ({
	type: groupActionTypes.GET_GROUP_LIST_FAILURE,
	payload: failureData,
});

export const getGroupListResponseResetStart = () => ({
	type: groupActionTypes.GET_GROUP_LIST_RESPONSE_RESET,
});

export const getGroupListResponseChanged = () => ({
	type: groupActionTypes.GET_GROUP_LIST_RESPONSE_CHANGED,
});
/** ***************** GET GROUP LIST END *********************** */

/** ***************** FETCH ALL GROUP START *********************** */
export const fetchAllGroupStart = (fetchGroup: any) => ({
	type: groupActionTypes.FETCH_ALL_GROUP_START,
	payload: fetchGroup,
});

export const fetchAllGroupSuccess = (successData: any) => ({
	type: groupActionTypes.FETCH_ALL_GROUP_SUCCESS,
	payload: successData,
});

export const fetchAllGroupFailure = (failureData: any) => ({
	type: groupActionTypes.FETCH_ALL_GROUP_FAILURE,
	payload: failureData,
});

export const fetchAllGroupResponseResetStart = () => ({
	type: groupActionTypes.FETCH_ALL_GROUP_RESPONSE_RESET_START,
});

export const fetchAllGroupResponseChanged = () => ({
	type: groupActionTypes.FETCH_ALL_GROUP_RESPONSE_CHANGED,
});
/** ***************** FETCH ALL GROUP END *********************** */

/** ***************** FETCH ALL APPROVED MEMBER START *********************** */
export const fetchAllApprovedMemberStart = (fetchGroup: any) => ({
	type: groupActionTypes.FETCH_ALL_APPROVED_MEMBER_START,
	payload: fetchGroup,
});

export const fetchAllApprovedMemberSuccess = (successData: any) => ({
	type: groupActionTypes.FETCH_ALL_APPROVED_MEMBER_SUCCESS,
	payload: successData,
});

export const fetchAllApprovedMemberFailure = (failureData: any) => ({
	type: groupActionTypes.FETCH_ALL_APPROVED_MEMBER_FAILURE,
	payload: failureData,
});

export const fetchAllApprovedMemberResponseResetStart = () => ({
	type: groupActionTypes.FETCH_ALL_APPROVED_MEMBER_RESPONSE_RESET_START,
});

export const fetchAllApprovedMemberResponseChanged = () => ({
	type: groupActionTypes.FETCH_ALL_APPROVED_MEMBER_RESPONSE_CHANGED,
});
/** ***************** FETCH ALL APPROVED MEMBER END *********************** */

/** ***************** GET ALL OFFICER LIST START *********************** */
export const getAllOfficerStart = (getData: any) => ({
	type: groupActionTypes.GET_ALL_OFFICER_START,
	payload: getData,
});

export const getAllOfficerSuccess = (successData: any) => ({
	type: groupActionTypes.GET_ALL_OFFICER_SUCCESS,
	payload: successData,
});

export const getAllOfficerFailure = (failureData: any) => ({
	type: groupActionTypes.GET_ALL_OFFICER_FAILURE,
	payload: failureData,
});

export const getAllOfficerResponseResetStart = () => ({
	type: groupActionTypes.GET_ALL_OFFICER_RESPONSE_RESET,
});

export const getAllOfficerResponseChanged = () => ({
	type: groupActionTypes.GET_ALL_OFFICER_RESPONSE_CHANGED,
});
/** ***************** GET ALL OFFICER LIST END *********************** */

/** ***************** GET ALL GROUP DETAILS START *********************** */
export const getAllGroupDetailsStart = (getData: any) => ({
	type: groupActionTypes.GET_ALL_GROUP_DETAILS_START,
	payload: getData,
});

export const getAllGroupDetailsSuccess = (successData: any) => ({
	type: groupActionTypes.GET_ALL_GROUP_DETAILS_SUCCESS,
	payload: successData,
});

export const getAllGroupDetailsFailure = (failureData: any) => ({
	type: groupActionTypes.GET_ALL_GROUP_DETAILS_FAILURE,
	payload: failureData,
});

export const getAllGroupDetailsResponseResetStart = () => ({
	type: groupActionTypes.GET_ALL_GROUP_DETAILS_RESPONSE_RESET,
});

export const getAllGroupDetailsResponseChanged = () => ({
	type: groupActionTypes.GET_ALL_GROUP_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET ALL GROUP DETAILS END *********************** */

/** ***************** GET BRANCH OFFICER LIST START *********************** */
export const getBranchOfficerStart = (getData: any) => ({
	type: groupActionTypes.GET_BRANCH_OFFICER_START,
	payload: getData,
});

export const getBranchOfficerSuccess = (successData: any) => ({
	type: groupActionTypes.GET_BRANCH_OFFICER_SUCCESS,
	payload: successData,
});

export const getBranchOfficerFailure = (failureData: any) => ({
	type: groupActionTypes.GET_BRANCH_OFFICER_FAILURE,
	payload: failureData,
});

export const getBranchOfficerResponseResetStart = () => ({
	type: groupActionTypes.GET_BRANCH_OFFICER_RESPONSE_RESET,
});

export const getBranchOfficerResponseChanged = () => ({
	type: groupActionTypes.GET_BRANCH_OFFICER_RESPONSE_CHANGED,
});
/** ***************** GET BRANCH OFFICER LIST END *********************** */

/** ***************** UPDATE EXIST GROUP START *********************** */
export const updateExistGroupStart = (addData: any) => ({
	type: groupActionTypes.UPDATE_EXIST_GROUP_START,
	payload: addData,
});

export const updateExistGroupSuccess = (successData: any) => ({
	type: groupActionTypes.UPDATE_EXIST_GROUP_SUCCESS,
	payload: successData,
});

export const updateExistGroupFailure = (failureData: any) => ({
	type: groupActionTypes.UPDATE_EXIST_GROUP_FAILURE,
	payload: failureData,
});

export const updateExistGroupResponseResetStart = () => ({
	type: groupActionTypes.UPDATE_EXIST_GROUP_RESPONSE_RESET,
});

export const updateExistGroupResponseChanged = () => ({
	type: groupActionTypes.UPDATE_EXIST_GROUP_RESPONSE_CHANGED,
});
/** ***************** UPDATE EXIST GROUP END *********************** */

/** ***************** REMOVE MEMBER FROM GROUP START *********************** */
export const removeMemberFromGroupStart = (addData: any) => ({
	type: groupActionTypes.REMOVE_MEMBER_FROM_START,
	payload: addData,
});

export const removeMemberFromGroupSuccess = (successData: any) => ({
	type: groupActionTypes.REMOVE_MEMBER_FROM_SUCCESS,
	payload: successData,
});

export const removeMemberFromGroupFailure = (failureData: any) => ({
	type: groupActionTypes.REMOVE_MEMBER_FROM_FAILURE,
	payload: failureData,
});

export const removeMemberFromGroupResponseResetStart = () => ({
	type: groupActionTypes.REMOVE_MEMBER_FROM_RESPONSE_RESET,
});

export const removeMemberFromGroupResponseChanged = () => ({
	type: groupActionTypes.REMOVE_MEMBER_FROM_RESPONSE_CHANGED,
});
/** ***************** REMOVE MEMBER FROM GROUP END *********************** */

/** ***************** REMOVE GROUP START *********************** */
export const deleteGroupResponse = (addData: any) => ({
	type: groupActionTypes.DELETE_GROUP_START,
	payload: addData,
});

export const deleteGroupSuccess = (successData: any) => ({
	type: groupActionTypes.DELETE_GROUP_SUCCESS,
	payload: successData,
});

export const deleteGroupFailure = (failureData: any) => ({
	type: groupActionTypes.DELETE_GROUP_FAILURE,
	payload: failureData,
});

export const deleteGroupResponseResetStart = () => ({
	type: groupActionTypes.DELETE_GROUP_RESPONSE_RESET,
});

export const deleteGroupResponseChanged = () => ({
	type: groupActionTypes.DELETE_GROUP_RESPONSE_CHANGED,
});
/** ***************** REMOVE GROUP END *********************** */
